import { RouteObject } from 'react-router-dom';
import { Cities } from '../index';
import { CreateCities, EditCities } from '../pages';

const CitiesRoutes: RouteObject[] = [
  {
    path: 'geography/cities',
    element: <Cities />,
  },
  {
    path: 'geography/cities/create',
    element: <CreateCities />,
  },
  {
    path: 'geography/cities/edit/:id',
    element: <EditCities />,
  },
];

export default CitiesRoutes;
